module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-de-DE.d04f235f.jpg";